module.exports = __webpack_public_path__ + "static/media/new5.a1b779bb.png";